import {
  getSubscriptionUrl,
  isExpired,
  isPaymentOverdue,
  isSubscriptionAdmin
} from '../../domain/functions/subscription';
import { CUSTOMER_PORTAL_URL } from '../../service/auth.service';
import { getLoggedInUserProfile } from '../../store/auth.selectors';
import { AuthStore } from '../../store/auth.state';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input
} from '@angular/core';
import { Space } from '@ppl/graphql-user-api';
import { I18nService } from '@ppl/i18n';
import type { OnInit } from '@angular/core';

export const UPGRADE_TO_COMMERCIAL_LINK_PATH = 'purchase-upgrade';
export const ORDERS_LINK_PATH = 'orders';

@Component({
    selector: 'ppl-space-access-forbidden',
    templateUrl: './space-access-forbidden.component.html',
    styleUrls: ['./space-access-forbidden.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpaceAccessForbiddenComponent implements OnInit {
  @Input() space: Space;

  icon = 'high-priority';
  title = this.i18nService.translate('Space access forbidden');
  subtitle: string;
  actionLink: string;
  actionText: string;
  isTrialExpired = false;

  constructor(
    @Inject(CUSTOMER_PORTAL_URL) private customerPortalUrl,
    private store: AuthStore,
    private i18nService: I18nService
  ) { }

  ngOnInit() {
    this.isTrialExpired = this.space.subscription.isTrial && isExpired(this.space.subscription);

    if (this.isTrialExpired) {
      this.initTrialExpired();
    } else if (isPaymentOverdue(this.space.subscription)) {
      this.initPaymentOverdue();
    }
  }

  initTrialExpired() {
    this.icon = 'icon-trial-error';
    this.title = this.i18nService.translate('Your Trial Has Expired');
    this.subtitle = this.i18nService.translate('Or Contact Sales for More Information:');
    if (isSubscriptionAdmin(this.space.subscription, this.store.get(getLoggedInUserProfile).email)) {
      this.actionLink = this.customerPortalUrl + getSubscriptionUrl(this.space.subscription, UPGRADE_TO_COMMERCIAL_LINK_PATH);
    }
    this.actionText = this.i18nService.translate('Purchase A Plan & Continue Using Coevera CRM!');
  }

  initPaymentOverdue() {
    this.icon = 'icon-payment-error';
    this.title = this.i18nService.translate('Your payment is due!');
    this.subtitle = this.i18nService.translate('You have to pay before continue work');
    if (isSubscriptionAdmin(this.space.subscription, this.store.get(getLoggedInUserProfile).email)) {
      this.actionLink = this.customerPortalUrl + getSubscriptionUrl(this.space.subscription, ORDERS_LINK_PATH);
    }
    this.actionText = this.i18nService.translate('Pay');
  }
}
